import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useProfileChartsDataContext } from './hooks/useProfileChartsDataContext';

export const Gender = () => {
    const { chartData } = useProfileChartsDataContext();

    return (
        <Donut
            title={'Sexo'}
            subtitles={chartData?.gender?.map((item) => item.description)}
            chartData={chartData?.gender || []}
            colors={defaultColors.slice(0, chartData?.gender?.length) || []}
            height={400}
            className="aligned-container"
        />
    );
};
